const config = {
  activeDir: 'ltr', // This can be ltr or rtl
  activeMode: 'light', // This can be light or dark
  activeTheme: 'BLUE_THEME', // BLUE_THEME, GREEN_THEME, AQUA_THEME, PURPLE_THEME, ORANGE_THEME
  activeLayout: 'vertical', // This can be vertical or horizontal
  isLayout: 'boxed', // This can be full or boxed
  isSidebarHover: false,
  isCollapse: 'full-sidebar',
  isLanguage: 'en',
  isCardShadow: true,
  isMobileSidebar: false,
  isHorizontal: false,
  isBorderRadius: 7,
  sidebarWidth: 300,
  miniSidebarWidth: 87,
  topbarHeight: 70,
};

export default config;
